import { getDictionary } from '@/dictionaries/dictionaries';

const AVAILABLE_LANGUAGES = [
  'en-US',
  'es-AR',
  'es-EC',
  'es-MX',
  'es-PE',
  'es-UY',
  'pt-BR',
];

function resolveLangAndDictionary(file) {
  // Determine initial language preference (localStorage user > localStorage company > default).
  let lang = 'en-US';

  if (process.env.NODE_ENV !== 'test') {
    if (
      typeof window !== 'undefined' &&
      typeof window.localStorage !== 'undefined'
    ) {
      const userLanguage = localStorage.getItem('user_language');
      const companyLanguage = localStorage.getItem('company_language');

      lang = userLanguage || companyLanguage || lang;
      if (lang === 'en') lang = 'en-US';
    }
  }

  // Keep existing behavior: in development/test use the file dictionary directly.
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'test' ||
    lang === undefined
  ) {
    return { lang, translations: file };
  }

  // Validate localStorage language and fallback to prefix match / default.
  let translations = getDictionary(lang);
  if (!translations) {
    const languagePrefix = (lang || '').split('-')[0];
    const matchingLang = AVAILABLE_LANGUAGES.find((availableLang) =>
      availableLang.startsWith(languagePrefix)
    );
    if (matchingLang) {
      translations = getDictionary(matchingLang);
      if (translations) return { lang: matchingLang, translations };
    }

    lang = 'en-US';
    translations = getDictionary(lang);
  }

  return { lang, translations };
}

export default function Trans(file, keyJson, value) {
  const { translations } = resolveLangAndDictionary(file);

  const getString = (dict) => {
    let valueString;
    if (keyJson.includes('.')) {
      const keysJson = keyJson.split('.');
      valueString = dict;
      keysJson.forEach((key) => {
        if (valueString !== undefined) {
          valueString = valueString[key];
        }
      });
    } else {
      valueString = dict?.[keyJson];
    }

    if (valueString !== undefined) {
      if (Array.isArray(value)) {
        value.forEach((val, i) => {
          valueString = valueString.replace(`\${value${i}}`, () =>
            String(val ?? '')
          );
        });
      } else if (value) {
        valueString = valueString.replace(`\${value}`, () => String(value));
      }
    }

    return valueString;
  };

  const valueString = getString(translations);

  if (valueString) {
    return valueString;
  }

  return getString(file);
}
